import Linkify from 'react-linkify';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    divMensagem: {
        fontSize: 12,
        whiteSpace: 'pre-line'
    },
})

const Mensagem = ({ sm }) => {
    const classes = useStyles();


    return (
        <>
            {sm.mensagem &&
                <div className={classes.divMensagem}>
                    <Linkify
                        properties={{
                            target: '_blank',
                            style: { color: '#177c8a' },
                        }}
                    >
                        {sm.mensagem}
                    </Linkify>
                </div>}
        </>
    )
}

export default Mensagem;